// extracted by mini-css-extract-plugin
export default {"container":"CategoryMenuContainer_container__UYcDC"};